import { Box, Button, Grid, Paper, Skeleton, Switch } from "@mui/material";

interface FormSkeletonProps {
  height: number;
  lines?: number;
}

export function ChatOpsFormSkeleton({ height, lines = 1 }: FormSkeletonProps) {
  return (
    <Paper sx={{ height }}>
      <Box>
        <Grid container spacing={5} sx={{ p: 2 }}>
          <Grid size={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Skeleton animation="wave">
              <Switch />
            </Skeleton>
          </Grid>
          {Array.from({ length: lines }).map((_, index) => (
            <Grid size={12} key={index}>
              <Skeleton
                variant="text"
                width="100%"
                height={60}
                animation="wave"
              />
            </Grid>
          ))}
          <Grid size={12}>
            <Skeleton animation="wave">
              <Button variant="contained">Save</Button>
            </Skeleton>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
